import { useEffect, useState } from 'react';

const SplashScreen = ({ onFinish }) => {
  const [logoSlideIn, setLogoSlideIn] = useState(false);
  const [screenSlideOut, setScreenSlideOut] = useState(false);

  useEffect(() => {
    setLogoSlideIn(true);

    // Start whole screen slide out after 1.5 seconds
    const slideOutTimeout = setTimeout(() => {
      setScreenSlideOut(true);
    }, 1500);

    // Complete splash screen
    const completeTimeout = setTimeout(() => {
      setLogoSlideIn(false);
      onFinish();
    }, 2200);

    return () => {
      clearTimeout(slideOutTimeout);
      clearTimeout(completeTimeout);
    };
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transform transition-transform duration-700 ease-in-out bg-secondary ${
        screenSlideOut ? '-translate-x-full' : 'translate-x-0'
      }`}
    >
      <div className='text-center overflow-hidden'>
        <h1
          className={`text-6xl md:text-7xl lg:text-8xl
            transform transition-all duration-700 ease-in-out
            ${
              !logoSlideIn
                ? 'translate-x-full opacity-0'
                : 'translate-x-0 opacity-100'
            }
          `}
          style={{ fontFamily: "'Teko', sans-serif" }}
        >
          <span className='text-yellow-500'>The</span>
          <span className='text-white'>Champs</span>
        </h1>
      </div>
    </div>
  );
};

export default SplashScreen;
